import React from "react";

interface UserDashboardBoxProps {
  title: string;
  mainText: string | number;
  subText: string;
  mainTextColor?: string;
  subTextColor?: string;
}

const UserDashboardBox: React.FC<UserDashboardBoxProps> = ({
  title,
  mainText,
  subText,
  mainTextColor,
  subTextColor,
}) => {
  return (
    <div className="bg-gray-100 rounded-lg p-4 shadow-sm">
      <div className="text-sm text-gray-600">{title}</div>
      <div
        className="text-2xl font-bold mt-1"
        style={{ color: mainTextColor || "#111827" }}
      >
        {mainText}
      </div>
      <div
        className="text-sm mt-1"
        style={{ color: subTextColor || "#4b5563" }}
      >
        {subText}
      </div>
    </div>
  );
};

export default UserDashboardBox;
